import React, { useEffect, useMemo, useState } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import './ServicesBlock.css'
import ServicesCard from './ServicesCard'
import { useServices } from '../../hooks/useServices'
import car1 from '../../asset/main-slider/car1.avif'
import car2 from '../../asset/main-slider/car2.avif'
import car3 from '../../asset/main-slider/car3.avif'
import car4 from '../../asset/main-slider/car4.avif'
import car5 from '../../asset/main-slider/car5.avif'
import car6 from '../../asset/main-slider/car6.avif'
import car7 from '../../asset/main-slider/car7.avif'
import car8 from '../../asset/main-slider/car8.avif'

// Машины идут по кругу car1 → car8, затем снова car1, по порядку карточек
const carVisuals = [
  { image: car1, carStyle: { '--car-right': '-35%', '--car-width': '98%' } },
  { image: car2, carStyle: { '--car-right': '-38%', '--car-width': '102%' } },
  { image: car3, carStyle: { '--car-right': '-33%', '--car-width': '96%' } },
  { image: car4, carStyle: { '--car-right': '-37%', '--car-width': '104%' } },
  { image: car5, carStyle: { '--car-right': '-34%', '--car-width': '98%' } },
  { image: car6, carStyle: { '--car-right': '-38%', '--car-width': '102%' } },
  { image: car7, carStyle: { '--car-right': '-36%', '--car-width': '100%' } },
  { image: car8, carStyle: { '--car-right': '-35%', '--car-width': '99%' } },
]

const ServicesBlock = () => {
  const { data: services = [] } = useServices()
  const getCardsPerView = () => {
    if (typeof window === 'undefined') {
      return 3
    }
    if (window.innerWidth < 800) {
      return 1
    }
    if (window.innerWidth < 1100) {
      return 2
    }
    return 3
  }

  const [cardsPerView, setCardsPerView] = useState(getCardsPerView)
  const maxOffset = Math.max(services.length - cardsPerView, 0)
  const [offset, setOffset] = useState(0)

  const cardVisuals = useMemo(
    () => services.map((_, index) => carVisuals[index % carVisuals.length]),
    [services]
  )

  const indicatorsCount = maxOffset + 1

  useEffect(() => {
    const handleResize = () => {
      setCardsPerView(getCardsPerView())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    setOffset((prev) => Math.min(prev, maxOffset))
  }, [maxOffset])

  const handlePrev = () => {
    setOffset((prev) => Math.max(prev - 1, 0))
  }

  const handleNext = () => {
    setOffset((prev) => Math.min(prev + 1, maxOffset))
  }

  return (
    <section className="communication-block" aria-label="Услуги детейлинга">
      <div className="communication-block__inner">
        <div className="communication-block__viewport">
          <div
            className="communication-block__track"
            style={{ '--services-offset': offset, '--cards-per-view': cardsPerView }}
          >
            {services.map((service, index) => {
              const config = cardVisuals[index]

              return (
                <ServicesCard
                  key={service.slug}
                  title={service.title}
                  slug={service.slug}
                  image={config?.image}
                  carStyle={config?.carStyle}
                />
              )
            })}
          </div>
        </div>
      </div>

      {indicatorsCount > 1 && (
        <div className="communication-block__controls">
          <div className="communication-block__indicator" aria-label="Состояние слайдера услуг">
            {Array.from({ length: indicatorsCount }).map((_, index) => (
              <button
                key={`service-dot-${index}`}
                type="button"
                className={`communication-block__dot ${index === offset ? 'is-active' : ''}`}
                onClick={() => setOffset(index)}
                aria-label={`Перейти к набору услуг ${index + 1}`}
              />
            ))}
          </div>

          <div className="communication-block__arrows">
            <button
              type="button"
              className="communication-block__arrow"
              onClick={handlePrev}
              disabled={offset === 0}
              aria-label="Предыдущие услуги"
            >
              <ChevronLeft size={18} strokeWidth={2.4} aria-hidden="true" />
            </button>
            <button
              type="button"
              className="communication-block__arrow"
              onClick={handleNext}
              disabled={offset === maxOffset}
              aria-label="Следующие услуги"
            >
              <ChevronRight size={18} strokeWidth={2.4} aria-hidden="true" />
            </button>
          </div>
        </div>
      )}
    </section>
  )
}

export default ServicesBlock